<template>
	<div class="mainWrapper products">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h1>Export PI</h1>

		<div class="links">
			<b-button type="is-info"
				><router-link to="/pi">
					Back to Purchase Invoice List
				</router-link></b-button
			>
		</div>

		<div class="general-search">
			<!-- <div>
				<b-autocomplete
					v-model="brandSuggestions"
					:data="filteredBrands"
					:open-on-focus="true"
					placeholder="Brands (Optional)"
					field="name"
					@select="option => (selectedBrand = option)"
					class="brandAutocomplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</div> -->
			<div>
				<b-datepicker :date-formatter="dateFormatter" placeholder="Starting Date" v-model="startingDate" icon="calendar-today">
					<button class="button is-danger" @click="fromDate = null">
						<b-icon icon="close"></b-icon>
						<span>Clear</span>
					</button>
				</b-datepicker>
			</div>

			<div>
				<b-datepicker
					:date-formatter="dateFormatter"
					placeholder="Ending Date"
					v-model="endingDate"
					icon="calendar-today"
					:min-date="minDate"
					:max-date="maxDate"
				>
					<button class="button is-danger" @click="toDate = null">
						<b-icon icon="close"></b-icon>
						<span>Clear</span>
					</button></b-datepicker
				>
			</div>

			<div>
				<b-button type="is-info" @click="exportPoPi()">Export</b-button>
			</div>
		</div>

		<div v-if="progress > 0">
			<br /><br />
			<b-progress :value="Math.ceil(progress)" show-value format="percent" type="is-success" size="is-medium"></b-progress>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Products',
	data: function() {
		return {
			limit: 20,
			isLoading: false,
			brands: [], // To store brands
			allBrands: [],
			selectedBrand: null,
			brandSuggestions: '',
			pi: [],
			exportPi: [],
			totalLoop: 0,
			progress: 0,
			startingDate: null,
			endingDate: null,
			minDate: null,
			maxDate: null
		}
	},

	watch: {
		startingDate: function(data) {
			if (data !== null) {
				this.minDate = data
				this.maxDate = new Date(data.getFullYear(), data.getMonth(), data.getDate() + 30)

				this.endingDate = data
			} else {
				this.endingDate = null
			}
		}
	},

	mounted: async function() {
		await this.getBrands()

		const data = {
			populate: ['suppliers']
		}

		const apiGetWarehouse = await this.$api.getWarehouse({ data })

		this.supplier = apiGetWarehouse.data.suppliers[0]._id

		// Get brands name which are related to this warehouse
		await Promise.all(
			apiGetWarehouse.data.suppliers[0].brand.map(async brand => {
				const brandData = {
					id: brand
				}

				const apiGetBrand = await this.$api.getBrand({ data: brandData })

				if (apiGetBrand !== undefined) {
					this.brands.push(apiGetBrand.data.list[0])
				}
			})
		)
	},

	computed: {
		filteredBrands() {
			return this.brands.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.brandSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	methods: {
		// Export products on user click
		exportPoPi: async function() {
			// Make sure fromDate is not empty
			if (this.startingDate == null || this.endingDate == null) {
				this.$swal.fire({
					icon: 'error',
					title: 'Error...',
					text: 'Please enter Starting date'
				})

				return
			}

			this.isLoading = true

			const data = {
				limit: 1000,
				populate: ['author'],
				sort: {
					updatedAt: 'desc'
				}
			}

			if (this.searchPI !== null && this.searchPI !== '') {
				data.code = this.searchPI
			}

			data.time = {}
			data.time.updatedAt = {
				$gte: this.$moment(this.startingDate)
					.set({ hour: 0 })
					.format('x')
			}

			data.time.updatedAt.$lte = this.$moment(this.endingDate)
				.set({ hour: 23 })
				.format('x')

			const result = await this.$api.getPI({ data })
			const purchase_invoice = []
			// Make sure result isn't blank
			if (result.data.count > 0) {
				// Loop every PI for details
				await Promise.all(
					result.data.list.map(async pi => {
						const purchase_invoice_detail = {}
						purchase_invoice_detail.pi = pi.code
						purchase_invoice_detail.author = pi.author.name
						purchase_invoice_detail.po = pi.purchase_order
						purchase_invoice_detail.products = []

						const data = {
							purchase_invoice: pi._id,
							populate: ['product'],
							limit: 1000
						}

						// Get PI Item Details
						const piDetailResult = await this.$api.getPiItemDetail({ data })

						// Get PO Item Details
						const poResult = await this.getPoDetail({
							id: pi.purchase_order
						})

						// console.log(piDetailResult)
						// console.log(poResult);

						// Loop all the PI Products
						piDetailResult.data.list.map(piItem => {
							const po_products = {}
							// Search for same in PO Items
							const product_match = poResult.data.purchase_order_items.filter(product => {
								return piItem.product._id == product.product
							})

							let product_price =
								piItem.product.commission > 0 || piItem.product.original_price < 2 ? piItem.product.price : piItem.product.original_price

							po_products.bd_code = piItem.product.bd_code
							po_products.barcode = piItem.product.barcode
							po_products.name = piItem.product.name
							po_products.price = product_price
							po_products.requestedQty = product_match[0].qty
							po_products.receivedQty = piItem.qty
							po_products.balance = piItem.qty - product_match[0].qty
							po_products.remark = piItem.remark
							po_products.createdAt = piItem.createdAt

							purchase_invoice_detail.products.push(po_products)
						})

						purchase_invoice.push(purchase_invoice_detail)
					})
				)
				this.isLoading = false
				this.generateCSV(purchase_invoice)
			} else {
				this.isLoading = false
				this.$swal.fire({
					icon: 'error',
					title: 'Error...',
					text: 'Nothing found!'
				})

				return
			}
		},

		generateCSV: function(purchase_invoice) {
			let export_csv = ''

			// Loop data
			purchase_invoice.map(pi => {
				// const firstRowArray = [pi.pi, pi.author]

				// let firstRow = firstRowArray.join(',')

				// export_csv += firstRow + '\r\n'

				export_csv += 'PI CODE,DATE,TIME,ADMIN NAME,BD CODE,BARCODE,NAME,REQUESTED QUANTITY,RECEIVED QUANTITY,PRICE,NET AMOUNT,BALANCE,REMARK\r\n'

				let total_request = 0
				let total_received = 0
				let total_net_price = 0

				// Map all the PI products
				pi.products.map(piProducts => {
					const remark = piProducts.remark ? '"' + piProducts.remark + '"' : ''

					const toAdd = [
						pi.pi,
						this.$moment(piProducts.createdAt).format('DD/MM/YY'),
						this.$moment(piProducts.createdAt).format('hh:mm a'),
						pi.author,
						piProducts.bd_code,
						piProducts.barcode,
						'"' + piProducts.name + '"',
						piProducts.requestedQty,
						piProducts.receivedQty,
						piProducts.price,
						piProducts.receivedQty * piProducts.price,
						piProducts.balance,
						remark
					]

					total_request += piProducts.requestedQty
					total_received += piProducts.receivedQty
					total_net_price += piProducts.receivedQty * piProducts.price

					let row = toAdd.join(',')

					export_csv += row + '\r\n'
				})

				export_csv += ',,,,,,Total,' + total_request + ',' + total_received + ',,' + total_net_price

				export_csv += '\r\n\r\n'
			})

			let filename_date = this.$moment().format('DDMMYYhhmmss')

			var csvData = new Blob([export_csv], { type: 'text/csv' }) //new way
			var csvUrl = URL.createObjectURL(csvData)

			var link = document.createElement('a')
			link.setAttribute('href', csvUrl)
			link.setAttribute('download', 'Purchase_Invoice_' + filename_date + '.csv')
			document.body.appendChild(link) // Required for FF

			link.click()
			link.remove()

			// Reset all the fields
			this.fromDate = null
			this.toDate = null
			this.minDate = null
			this.searchPI = null
		},

		getPoDetail: async function(data) {
			return await this.$api.getPODetail({ data })
		},

		getPiItems: async function(data) {
			return await this.$api.getPIDetail({ data })
		},

		// Get all the brands
		getBrands: async function() {
			const data = {
				limit: 1000,
				sort: {
					name: 'asc'
				}
			}
			const apiGetBrands = await this.$api.getBrand({ data })

			if (apiGetBrands !== undefined) {
				this.allBrands = apiGetBrands.data.list
			}
		},

		// For calender format
		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		}
	}
}
</script>

<style scoped>
@import '../styles/Products.css';
</style>
